import {FETCH_USER} from "../types";
export const SYNC_INFO = "SYNC_INFO"
export const SYNC_PROGRESS = "SYNC_PROGRESS"
export const IN_SYNC = "IN_SYNC"
